import { render, staticRenderFns } from "./SetGrade.vue?vue&type=template&id=ec36e69c&scoped=true"
import script from "./SetGrade.vue?vue&type=script&lang=js"
export * from "./SetGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec36e69c",
  null
  
)

export default component.exports